import { create } from 'zustand';

interface User {
  id: number;
  firebase_uid: string;
  display_name: string;
  legalName?: string;
  email: string;
  phone: string;
  photo_url?: string;
  role: string;
  created_at: string;
  updated_at: string;
}

interface UserState {
  user: User | null;
  isAuthorized: boolean;
  setUser: (user: User | null) => void;
  setIsAuthorized: (authorized: boolean) => void;
}

export const useUserStore = create<UserState>((set: (partial: Partial<UserState>) => void) => ({
  user: null,
  isAuthorized: false,
  setUser: (user: User | null) => set({ user }),
  setIsAuthorized: (authorized: boolean) => set({ isAuthorized: authorized }),
}));
